import * as ReactQuery from "@tanstack/react-query";
import { MutationOption, queryClient } from "libs/react-query";
import * as Brm from "services/brm";
// import * as KeyFactory from "./project-query-key-factory";
// import * as UserKeyFactory from "../user/user-query-key-factory";

interface IAddProjectWorkerProps {
  projectId: string;
  userId: any;
}

/**
 * Add a project worker
 *
 * @returns
 */
export const addProjectWorker = ({ projectId, userId }: IAddProjectWorkerProps) => {
  return projectId === null
    ? Promise.reject(new Error("Invalid projectId dto"))
    : Brm.projectApi.addProjectWorker(projectId, { body: userId });
};

interface ICreateProjectQueryProps {
  options?: MutationOption<typeof addProjectWorker>;
}

/**
 * Custom hook to add a project worker
 *
 * @returns react-query Mutation.
 */
export const useAddProjectWorker = ({ options }: ICreateProjectQueryProps = {}) => {
  return ReactQuery.useMutation({
    onSettled: async (/* data, context, variables */) => {
      // queryClient.invalidateQueries(KeyFactory.projectKeys.project(variables.projectId));
      // queryClient.invalidateQueries(KeyFactory.projectKeys.workers(variables.projectId));
      // queryClient.invalidateQueries(KeyFactory.projectKeys.access(variables.projectId));
      // queryClient.invalidateQueries(UserKeyFactory.userKeys.all);
      await queryClient.invalidateQueries();
    },
    ...options,
    mutationFn: addProjectWorker,
  });
};
